import { getStoreId } from "$/hooks/use-store-information"
import bookingStepOrderQueries from "$/lib/queries/booking-step-order-queries"
import customBookingSectionQueries from "$/lib/queries/custom-booking-section-queries"
import servicePackageQueries from "$/lib/queries/service-package-queries"
import washQueries from "$/lib/queries/wash-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/booking-order")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    if (storeId) {
      queryClient.prefetchQuery(bookingStepOrderQueries.list({ storeId }))
      queryClient.prefetchQuery(customBookingSectionQueries.list({ storeId }))
      queryClient.prefetchQuery(servicePackageQueries.list({ storeId }))
      queryClient.prefetchQuery(washQueries.list({ storeId }))
    }

    return {
      crumb: "alfred.settings.crumbs.bookingOrder",
    }
  },
})
